import React from 'react';

const MapPinIcon = () => (
    <svg width="24" height="35" viewBox="0 0 24 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.1889 12.733C23.1889 23.0196 11.5944 34.4492 11.5944 34.4492C11.5944 34.4492 0 23.0196 0 12.733C0 9.39852 1.22155 6.20064 3.39594 3.84282C5.57032 1.48501 8.51941 0.1604 11.5944 0.1604C14.6695 0.1604 17.6186 1.48501 19.793 3.84282C21.9673 6.20064 23.1889 9.39852 23.1889 12.733Z"
            fill="#246EFF"
        />
        <path
            d="M11.5944 18.4475C14.5051 18.4475 16.8646 15.889 16.8646 12.7328C16.8646 9.57664 14.5051 7.01807 11.5944 7.01807C8.68377 7.01807 6.32422 9.57664 6.32422 12.7328C6.32422 15.889 8.68377 18.4475 11.5944 18.4475Z"
            fill="white"
        />
    </svg>
);

export default MapPinIcon;
